module.exports = __webpack_public_path__ + "static/img/hezuo05.f1b62c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/imgsrc/hezuo05.jpg
// module id = e8zy
// module chunks = 1